import React, { useState } from "react";
import { withPrefix } from "gatsby";
import { useI18next } from "gatsby-plugin-react-i18next";

//react-boostrap
import { Card, Form, Button } from "react-bootstrap";
const InsightCard: React.FC = () => {
    const { t } = useI18next();
    const [validated, setValidated] = useState<boolean>(false);
    const handleSubmit = (e: React.SyntheticEvent) => {
        e.preventDefault();
        const form = e.currentTarget;
        if (form.checkValidity() === false) {
        }
        setValidated(true);
    };
    return (
        <Card className="insight-card">
            <Card.Body>
                <h5
                    dangerouslySetInnerHTML={{
                        __html: t("blog.know_more"),
                    }}
                ></h5>
                <Card.Text>{t("blog.subscribe")}</Card.Text>
                <Form noValidate validated={validated} onSubmit={handleSubmit}>
                    <Form.Group>
                        <Form.Label>{t("blog.email")}</Form.Label>
                        <Form.Control name="email" type="email" required></Form.Control>
                        <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                    </Form.Group>
                    <Button className="red-button" type="submit">
                        Submit
                    </Button>
                </Form>
            </Card.Body>
            <Card.Img variant="bottom" alt={t("img-alt.bg-box-email")} src={withPrefix("images/bg-box-email.svg")}></Card.Img>
        </Card>
    );
};

export default InsightCard;
